import script from "./ListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ListPage.vue?vue&type=script&setup=true&lang=js"

import "./ListPage.vue?vue&type=style&index=0&id=e48ab33e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e48ab33e"]])

export default __exports__